import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddBrokerComponent } from './add-broker.component';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { UnsortedKeyValueModule } from '@app/_shared/pipes';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { SentenceModule } from '@app/_shared/pipes/sentence/sentence.module';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';



@NgModule({
  declarations: [
    AddBrokerComponent
  ],
  imports: [
    CommonModule,
    MatSelectModule,
    UnsortedKeyValueModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    SentenceModule,
    MatDialogModule
  ],
  exports: [
    AddBrokerComponent
  ]
})
export class AddBrokerModule { }
